import React from 'react';

const SaveAsTemplateIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.1818
                12.9089C12.1818
                13.4876
                11.9519
                14.0425
                11.5428
                14.4517C11.1336
                14.8609
                10.5786
                15.0908
                10
                15.0908C9.42138
                15.0908
                8.8664
                14.8609
                8.45722
                14.4517C8.04805
                14.0425
                7.81818
                13.4876
                7.81818
                12.9089H2V17.9998H18V12.9089H12.1818Z"
                stroke="#595959"
                strokeWidth="1.25"
                strokeLinejoin="round"
            />
            
            <path
                d="M15.091
                10.7273V4.90909L12.1819
                2H4.90918V10.7273"
                stroke="#595959"
                strokeWidth="1.25"
                strokeLinejoin="round"
            />
            
            <path
                d="M12.1816
                2V4.90909H15.0907L12.1816
                2Z"
                stroke="#595959"
                strokeWidth="1.25"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SaveAsTemplateIcon;